import { store } from "@App/state";

export const claimNumberFieldIsRequired = (): boolean => {
  return (
    store.getState().analytics.source === "signal_iduna" &&
    !["online-meldung", "vertrieb"].includes(store.getState().analytics.medium ?? "")
  );
};
